// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d9f7f1bc","977":"4ab5229b"}[chunkId] + ".chunk.js";
};